var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-status"},[_c('span',{staticClass:"badge",style:(_vm.statusStyle)},[_vm._v(_vm._s(_vm.labelText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }